import axios from 'axios';

import { JOVENES } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarJovenes = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/jovenes/listar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: JOVENES.BUSCAR,
            payload: res.data.jovenes
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerJoven = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/jovenes/detalles`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: JOVENES.DETALLES,
                payload: res.data.joven
            });
        } catch (error){
            await dispatch(changeLoader(false));

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: JOVENES.DETALLES,
            payload: null
        });
    }
}

export const eliminarJoven = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/jovenes/eliminar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: JOVENES.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarJoven = () => dispatch => {
    dispatch({  
        type: JOVENES.DETALLES,
        payload: null
    });
}

export const cambioStatusJoven = (id, status) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id, 
        status
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/jovenes/status`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: JOVENES.EDITAR_JOVEN,
            payload: {
                _id: id,
                status
            }
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));
        
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const filtarJovenes = (opcion) => dispatch => {
    dispatch({
        type: JOVENES.FILTROS,
        payload: opcion
    });
}